if (!customElements.get('stock-countdown-timer')) {
  class StockCountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.interval = null;
      this.targetTime = null;
    }
    
    connectedCallback() {
      this.countdownType = this.dataset.countdownType;
      this.timerElement = this.querySelector('.countdown-timer');
      this.countdownContent = this.querySelector('.countdown-content');
      this.expiryContent = this.querySelector('.expiry-content');
      this.afterExpiry = this.dataset.afterExpiry;
      
      this.calculateTargetTime();
      this.startCountdown();
    }
    
    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
    
    calculateTargetTime() {
      const AEDT_OFFSET = 11 * 60 * 60 * 1000; // AEDT is UTC+11
      const useLocalTimezone = this.dataset.useLocalTimezone !== undefined;
      
      if (this.countdownType === 'static') {
        const targetDate = this.dataset.targetDate;
        const targetTimeStr = this.dataset.targetTime;
        
        if (!targetDate || !targetTimeStr) {
          console.error('Static countdown requires target date and time');
          return;
        }
        
        if (useLocalTimezone) {
          this.targetTime = new Date(targetDate + 'T' + targetTimeStr + ':00').getTime();
        } else {
          const utcTime = new Date(targetDate + 'T' + targetTimeStr + ':00Z').getTime();
          this.targetTime = utcTime - AEDT_OFFSET;
        }
        
      } 
      else if (this.countdownType === 'fixed') {
        const productId = this.dataset.productId || 'default';
        const storageKey = `stock_countdown_fixed_timer_${productId}`;
        const storedEndTime = sessionStorage.getItem(storageKey);
        
        if (storedEndTime) {
          this.targetTime = parseInt(storedEndTime);
          
          if (Date.now() >= this.targetTime) {
            this.targetTime = parseInt(storedEndTime);
          }
        } else {
          this.startNewFixedTimer(storageKey);
        }
      }
      else {
        const dailyHourRaw = this.dataset.dailyHour;
        const dailyMinuteRaw = this.dataset.dailyMinute;
        
        const dailyHour = dailyHourRaw !== undefined && dailyHourRaw !== null && dailyHourRaw !== '' 
          ? parseInt(dailyHourRaw) 
          : 3;
        const dailyMinute = dailyMinuteRaw !== undefined && dailyMinuteRaw !== null && dailyMinuteRaw !== '' 
          ? parseInt(dailyMinuteRaw) 
          : 30;
        
        const now = new Date();
        
        if (useLocalTimezone) {
          let target = new Date();
          target.setHours(dailyHour, dailyMinute, 0, 0);
          
          if (now >= target) {
            target.setDate(target.getDate() + 1);
          }
          
          this.targetTime = target.getTime();
        } else {
          const nowUTC = now.getTime();
          const nowAEDT = nowUTC + AEDT_OFFSET;
          
          const aedtDate = new Date(nowAEDT);
          const aedtYear = aedtDate.getUTCFullYear();
          const aedtMonth = aedtDate.getUTCMonth();
          const aedtDay = aedtDate.getUTCDate();
          
          let targetAEDT = Date.UTC(aedtYear, aedtMonth, aedtDay, dailyHour, dailyMinute, 0);
          
          if (nowAEDT >= targetAEDT) {
            targetAEDT = Date.UTC(aedtYear, aedtMonth, aedtDay + 1, dailyHour, dailyMinute, 0);
          }
          
          this.targetTime = targetAEDT - AEDT_OFFSET;
        }
      }
    }

    startNewFixedTimer(storageKey) {
      const hoursRaw = this.dataset.fixedHours;
      const minutesRaw = this.dataset.fixedMinutes;
      const secondsRaw = this.dataset.fixedSeconds;
      
      const hours = hoursRaw !== undefined && hoursRaw !== null && hoursRaw !== '' 
        ? parseInt(hoursRaw) 
        : 1;
      const minutes = minutesRaw !== undefined && minutesRaw !== null && minutesRaw !== '' 
        ? parseInt(minutesRaw) 
        : 30;
      const seconds = secondsRaw !== undefined && secondsRaw !== null && secondsRaw !== '' 
        ? parseInt(secondsRaw) 
        : 0;
      
      const durationMs = (hours * 60 * 60 * 1000) + (minutes * 60 * 1000) + (seconds * 1000);
      this.targetTime = Date.now() + durationMs;
      

      sessionStorage.setItem(storageKey, this.targetTime.toString());
    }
    
    updateCountdown() {
      const now = Date.now();
      const diff = this.targetTime - now;
      
      if (diff <= 0) {
        if (this.countdownType === 'dynamic') {
          location.reload();
        } 
        else if (this.countdownType === 'fixed') {
          this.countdownContent.classList.add('hidden');
          
          if (this.afterExpiry === 'hide') {
            this.classList.add('hidden');
          } else {
            this.expiryContent.classList.remove('hidden');
          }
          
          if (this.interval) {
            clearInterval(this.interval);
          }
        }
        else {
          this.countdownContent.classList.add('hidden');
          
          if (this.afterExpiry === 'hide') {
            this.classList.add('hidden');
          } else {
            this.expiryContent.classList.remove('hidden');
          }
          
          if (this.interval) {
            clearInterval(this.interval);
          }
        }
        return;
      }
      
      this.countdownContent.classList.remove('hidden');
      this.expiryContent.classList.add('hidden');
      
      // Calculate time components
      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / (24 * 60 * 60));
      const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
      const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
      const seconds = totalSeconds % 60;
      
      let displayText = '';
      
      if (this.countdownType === 'fixed') {
        const totalHours = days * 24 + hours;
        
        if (totalHours > 0) {
          displayText = String(totalHours).padStart(2, '0') + ':' + 
                       String(minutes).padStart(2, '0') + ':' + 
                       String(seconds).padStart(2, '0');
        } else {
          displayText = String(minutes).padStart(2, '0') + ':' + 
                       String(seconds).padStart(2, '0');
        }
        
      } 
      else if (this.countdownType === 'dynamic') {
        const maxHoursRaw = this.dataset.maxHoursDisplay;
        const minHoursRaw = this.dataset.minHoursDisplay;
        
        const maxHours = maxHoursRaw !== undefined && maxHoursRaw !== null && maxHoursRaw !== '' 
          ? parseInt(maxHoursRaw) 
          : 20;
        const minHours = minHoursRaw !== undefined && minHoursRaw !== null && minHoursRaw !== '' 
          ? parseInt(minHoursRaw) 
          : 1;
        
        let totalHours = days * 24 + hours;
        
        if (totalHours > maxHours) {
          totalHours = maxHours;
        }
        if (totalHours < minHours && days === 0) {
          totalHours = minHours;
        }
        
        if (totalHours > 0) {
          displayText = String(totalHours).padStart(2, '0') + ':' + 
                       String(minutes).padStart(2, '0') + ':' + 
                       String(seconds).padStart(2, '0');
        } else {
          displayText = String(minutes).padStart(2, '0') + ':' + 
                       String(seconds).padStart(2, '0');
        }

      } 
      else {
        if (days > 0) {
          displayText = String(days).padStart(2, '0') + ':' + 
                       String(hours).padStart(2, '0') + ':' + 
                       String(minutes).padStart(2, '0') + ':' + 
                       String(seconds).padStart(2, '0');
        } else if (hours > 0) {
          displayText = String(hours).padStart(2, '0') + ':' + 
                       String(minutes).padStart(2, '0') + ':' + 
                       String(seconds).padStart(2, '0');
        } else {
          displayText = String(minutes).padStart(2, '0') + ':' + 
                       String(seconds).padStart(2, '0');
        }
      }
      
      this.timerElement.textContent = displayText;
    }
    
    startCountdown() {
      if (!this.targetTime) return;
      
      this.updateCountdown();
      this.interval = setInterval(() => this.updateCountdown(), 1000);
    }
  }
  
  customElements.define('stock-countdown-timer', StockCountdownTimer);
}